import { LenderUser } from 'app/models/dto/lender-user.model';
import { Notification } from 'app/services/notification/notification.model';

export class SubscribeToNotificationChannels {
	static readonly type = '[Notifications] SubscribeToNotificationChannels';
	constructor(public lenderUser: LenderUser) {}
}

export class SubscribeToCallNotificationChannels {
	static readonly type = '[Notifications] SubscribeToCallNotificationChannels';
	constructor(public lenderUser: LenderUser) {}
}

export class CreateNotification {
	static readonly type = '[Notifications] CreateNotification';
	constructor(public notification: Notification, public rehydrate?: boolean) {}
}

export class DismissNotificationsForCallId {
	static readonly type = '[Notifications] DismissNotificationsForCallId';
	constructor(public callId: number) {}
}

export class DismissNotification {
	static readonly type = '[Notifications] DismissNotification';
	constructor(public id: string) {}
}

export class UnsubscribeFromNotificationChannels {
	static readonly type = '[Notifications] UnsubscribeFromNotificationChannels';
	constructor() {}
}
